var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "38px",
    viewBox: "0 0 32 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ppt_icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.358,0 L32,8.026 L32,35.45408 C32,36.8601528 30.8601528,38 29.45408,38 L2.54592,38 C1.13984721,38 1.72194254e-16,36.8601528 0,35.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,-1.07397625e-15 2.54592,0 L24.358,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.358,0 L32,8.026 L32,35.45408 C32,36.8601528 30.8601528,38 29.45408,38 L2.54592,38 C1.13984721,38 1.72194254e-16,36.8601528 0,35.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,-1.07397625e-15 2.54592,0 L24.358,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt_icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFAB00",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ppt_icons",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FD974D",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEC69A",
    mask: "url(#mask-4)",
    x: 24,
    y: -6.55172414,
    width: 12,
    height: 14.4137931,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("g", {
    id: "PPT",
    transform: "translate(6.620690, 8.685714)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 22.0689655,
    height: 21.7142857
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    opacity: 0.99,
    points: "4.4137931 3.25714286 7.72413793 3.25714286 7.72413793 19.5428571 4.4137931 19.5428571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6955968,3.25714286 L4.4137931,3.25714286 L4.4137931,13.0285714 L12.6955968,13.0285714 C14.8244032,13.0285714 16.5517241,11.3851948 16.5517241,9.35984416 L16.5517241,6.92587013 C16.5517241,4.90051947 14.8244032,3.25714286 12.6955968,3.25714286 Z M13.5639257,9.35984416 C13.5639257,9.81288312 13.1717772,10.185974 12.6955968,10.185974 L7.40159151,10.185974 L7.40159151,6.09974025 L12.6955968,6.09974025 C13.1717772,6.09974025 13.5639257,6.47283116 13.5639257,6.92587013 L13.5639257,9.35984416 L13.5639257,9.35984416 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    opacity: 0.99
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "#FEC69A",
    mask: "url(#mask-2)",
    x: 24,
    y: -6.55172414,
    width: 12,
    height: 14.4137931,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("g", {
    id: "PPT",
    transform: "translate(6.620690, 8.685714)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 22.0689655,
    height: 21.7142857
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    opacity: 0.99,
    points: "4.4137931 3.25714286 7.72413793 3.25714286 7.72413793 19.5428571 4.4137931 19.5428571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6955968,3.25714286 L4.4137931,3.25714286 L4.4137931,13.0285714 L12.6955968,13.0285714 C14.8244032,13.0285714 16.5517241,11.3851948 16.5517241,9.35984416 L16.5517241,6.92587013 C16.5517241,4.90051947 14.8244032,3.25714286 12.6955968,3.25714286 Z M13.5639257,9.35984416 C13.5639257,9.81288312 13.1717772,10.185974 12.6955968,10.185974 L7.40159151,10.185974 L7.40159151,6.09974025 L12.6955968,6.09974025 C13.1717772,6.09974025 13.5639257,6.47283116 13.5639257,6.92587013 L13.5639257,9.35984416 L13.5639257,9.35984416 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    opacity: 0.99
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.dbf444a7d8c72451ddfbf8a6dbf0726e.svg";
export { ForwardRef as ReactComponent };